import { RouteComponentProps } from '@reach/router';
import React, { Component } from 'react';

import Logo from '../Logo';

import logo from '../../assets/images/club-logo.svg';
import { IClub } from '../../store/player/clubs/store';

interface IProps extends RouteComponentProps {
  powered: boolean;
  club: IClub;
}

class PaymentHeader extends Component<IProps> {
  constructor(props: IProps) {
    super(props);
  }

  public render(): JSX.Element {
    return (
      <div className="payment-header">
        {this.props.club.profileImage ? (
          <img className="club-logo" src={this.props.club.profileImage} id="club-logo" />
        ) : (
          <img className="club-logo" src={logo} id="club-logo" />
        )}

        {this.props.powered && <Logo powered={true} />}

        <h1>CLUB FEES DUE TODAY</h1>

        {this.props.club.membershipPrice && (
          <div className="price-box">{this.props.club.membershipPrice}</div>
        )}

        <h1>CREDIT CARD INFORMATION</h1>
      </div>
    );
  }
}

export { PaymentHeader };
